import * as jose from 'jose'

let secretkey = new TextEncoder().encode(process.env.REACT_APP_DOCUMENTS_SECRET_KEY)

export function verifyToken(encrypted) {
  return jose.jwtVerify(encrypted,secretkey)
}
